var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1163 9.85018V34.4861C42.1163 36.753 40.3585 38.5921 38.1919 38.5921H4.18027C2.01367 38.5921 0.255859 36.753 0.255859 34.4861V9.85018C0.255859 7.58333 2.01367 5.74419 4.18027 5.74419H11.375L12.3807 2.92987C12.953 1.33025 14.4165 0.269531 16.0516 0.269531H26.3123C27.9475 0.269531 29.411 1.33025 29.9833 2.92987L30.9971 5.74419H38.1919C40.3585 5.74419 42.1163 7.58333 42.1163 9.85018ZM30.9971 22.1682C30.9971 16.5053 26.5985 11.9032 21.1861 11.9032C15.7736 11.9032 11.375 16.5053 11.375 22.1682C11.375 27.831 15.7736 32.4332 21.1861 32.4332C26.5985 32.4332 30.9971 27.831 30.9971 22.1682ZM28.3808 22.1682C28.3808 26.3169 25.1514 29.6958 21.1861 29.6958C17.2208 29.6958 13.9913 26.3169 13.9913 22.1682C13.9913 18.0194 17.2208 14.6405 21.1861 14.6405C25.1514 14.6405 28.3808 18.0194 28.3808 22.1682Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8b06c951ec3a8574bdf8f2d4826182a0.svg";
export { ForwardRef as ReactComponent };